export default class Email {
    constructor(email) {
        this.email = '';

        if (email) {
            this.email = email;
        }
    }

    toDto() {
        return {
            Email: this.email,
        };
    }
}